export const transformErrorResponse = (payload) => {
  if (!payload) {
    return;
  }

  const errorKeys = Object.keys(payload);
  return transformErrors(errorKeys, payload);
};

export const transformCustomError = (message) => {
  return {
    message,
  };
};

export const transformErrors = (keys, payload) => {
  return keys.reduce(
    (err, key) => {
      if (key === 'detail' || key === 'message') {
        err.message = payload[key];
      } else {
        err.details.push({
          key,
          value: payload[key],
        });
      }
      return err;
    },
    { details: [] },
  );
};

export const getServiceCodeError = (error) => {
  let message = 'Something went wrong';

  const err = (error && error.response && error.response.data) || {};
  if (err.error) {
    message = err.error;
  } else if (err.detail) {
    message = err.detail;
  } else if (err.message) {
    message = err.message;
  }

  return message;
};

export const getError = (error) => {
  const root =
    (error && error.response && error.response.data) ||
    (error && error.errors && error.errors._error) ||
    error;

  return (
    root.message || root.messages || root.details || root.detail || root.status
  );
};

export const handleSqlReportError = (e) => {
  const err = getError(e);
  const response = e.response;
  let error;

  if (!err) {
    if (response.status === 500) {
      error = 'Internal Server Error: status 500';
    } else {
      error = `Something went wrong: status ${response.status}`;
    }
  } else {
    if (Array.isArray(err)) {
      if (!err.length) {
        error = `Something went wrong: status ${response.status}`;
      } else if (err[0].key) {
        error = err
          .map((row) => `${row.key}: ${row.value || row.message}`)
          .join('; ');
      } else {
        error = err.join('; ');
      }
    } else {
      error = err;
    }
  }

  return error;
};
